import React from "react";
import BookCover from "#helpers/BookCover";
import { capitalize } from "#utils/utils";

const CommunityCard = ({ type, item }) => {
  const TEXT_COLOR_MAP = {
    club: "#61C7DC",
    list: "#F269BF",
    quest: "#61C7DC",
    readalong: "#B791E7",
  };

  return (
    <a
      href={item.link || `/${type}s/${item.uuid}`}
      style={{ borderColor: TEXT_COLOR_MAP[type], boxShadow: `1.8px 1.8px 0 0 ${TEXT_COLOR_MAP[type]}` }}
      className="no-hover relative w-fit h-fit flex flex-col bg-white border-2 rounded-default p-4 gap-3 cursor-pointer items-center"
    >
      <p style={{ color: TEXT_COLOR_MAP[type] }} className={`font-bold`}>
        {capitalize(type)}
      </p>

      <div className="grid grid-cols-2 gap-2 w-fit max-w-full min-h-[168px]">
        {item.book_details?.slice(0, 4).map((book, index) => (
          <BookCover key={index} book={book} size="w-[54px] h-[80px]" clickable={false} />
        ))}
      </div>
      <div className="flex flex-col gap-2 flex-grow text-center max-w-full justify-between items-center">
        <div className="flex flex-col gap-1">
          <p className="font-bold text-sm leading-tight w-[120px] md:w-[150px] text-ellipsis line-clamp-1">
            {item.name}
          </p>
        </div>
      </div>
    </a>
  );
};

export default CommunityCard;
